import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '../../ui/dropdown-menu.tsx'
import { MoreHorizontal, Settings, Trash2, RotateCcw, ShieldAlert } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../ui/tooltip.tsx'

function ActionsMenu({
  isOpen,
  setIsOpen,
  openDeleteDialog,
  openSettings,
  openRestoreDialog,
  isDeleted,
  canPermanentDelete = false,
  daysUntilPermanentDeleteAllowed = 0,
}: {
  isOpen: boolean,
  setIsOpen: (open: boolean) => void,
  openDeleteDialog: () => void,
  openSettings: () => void,
  openRestoreDialog: () => void,
  isDeleted: boolean,
  canPermanentDelete?: boolean,
  daysUntilPermanentDeleteAllowed?: number,
}) {

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <MoreHorizontal className="size-4 hover:bg-gray-50 hover:scale-110 cursor-pointer ml-auto mr-2" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {!isDeleted ? (
          <>
            <DropdownMenuItem onClick={() => {
              openSettings();
              setIsOpen(false);
            }}>
              <Settings className="size-4 mr-2" />
              Settings
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => {
              openDeleteDialog();
              setIsOpen(false);
            }} className="text-red-600 focus:text-red-600">
              <Trash2 className="size-4 mr-2" />
              Delete
            </DropdownMenuItem>
          </>
        ) : (
          <>
            <DropdownMenuItem onClick={() => {
              openRestoreDialog();
              setIsOpen(false);
            }} className="text-green-600 focus:text-green-600">
              <RotateCcw className="size-4 mr-2" />
              Restore Account
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            {canPermanentDelete ? (
              <DropdownMenuItem onClick={() => {
                openDeleteDialog();
                setIsOpen(false);
              }} className="text-red-600 focus:text-red-600">
                <Trash2 className="size-4 mr-2" />
                Permanently Delete
              </DropdownMenuItem>
            ) : (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="opacity-50 cursor-not-allowed">
                      <DropdownMenuItem disabled>
                        <ShieldAlert className="size-4 mr-2" />
                        Permanently Delete
                      </DropdownMenuItem>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent>
                    Available in {daysUntilPermanentDeleteAllowed} day(s)
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ActionsMenu